// extracted by mini-css-extract-plugin
export default {"navLinks":"NavbarMenu_navLinks__+aSJd","navLink":"NavbarMenu_navLink__IdiqS","activeNavLink":"NavbarMenu_activeNavLink__Eef3y"};